import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

/** Contrato `ValidacionSolicitudActivaRequestDTO` (backend Java). */
export interface ParDocumentoIntegrante {
  tipoDocumento: string;
  numeroDocumento: string;
}

export interface ValidacionSolicitudActivaRequest {
  numeroContrato: string;
  idTipoNovedad: number;
  idSubtipoNovedad?: number;
  noRegistrosIntegrantes?: string[];
  /** Si el servidor usa `modo-cruce-integrantes=DOCUMENTO`. */
  paresDocumentosIntegrantes?: ParDocumentoIntegrante[];
}

/** Contrato `ValidacionSolicitudActivaResponseDTO` (backend Java). */
export interface ValidacionSolicitudActivaResponse {
  conflicto: boolean;
  numeroSolicitudTraslado?: number;
  mensaje?: string | null;
  cruceIntegrantesAplicado: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ValidacionSolicitudActivaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.VALIDACION_SOLICITUD_ACTIVA}`;

  constructor(private http: HttpClient) {}

  validar(
    body: ValidacionSolicitudActivaRequest
  ): Observable<ValidacionSolicitudActivaResponse> {
    return this.http.post<ValidacionSolicitudActivaResponse>(this.apiUrl, body);
  }
}
